/* eslint no-prototype-builtins: 0 */

'use strict';

angular.module('lingApp')
  .factory('RipState', function ($rootScope) {
    function getState(scope) {
      while (scope) {
        if (scope.hasOwnProperty('__ripState')) {
          return scope.__ripState;
        }

        scope = scope.$parent;
      }

      return undefined;
    }

    return {
      setState: function(scope, key) {
        if (!key) {
          scope.__ripState = {};

        } else {
          var state = getState(scope.$parent);
          if (!state[key]) {
            state[key] = {};
          }

          scope.__ripState = state[key];
        }
      },

      get: function(scope, key, initFunction) {
        var state = getState(scope);
        var value = state[key];

        if (!value) {
          value = initFunction();
          state[key] = value;
        }

        return value;
      },

      initScope: function(scope, key, initFunction) {
        angular.extend(scope, this.get(scope, key, initFunction));
      }
    };
  });
